import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { AuthSubmitButton, AuthPageLayout, AuthCard } from './components';
import '../../styles/components.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await axios.post('/api/auth/forgot-password', { email });
      toast.success(response.data.message);
      setEmailSent(true);
    } catch (error) {
      const message = error.response?.data?.message || 'Error sending reset email. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  // Success state - email sent
  if (emailSent) {
    return (
      <AuthPageLayout showFooter={false}>
        <div className="text-center space-y-4">
          <h2 className="text-3xl font-bold text-gray-900">
            Check Your Email
          </h2>
          <p className="text-sm text-gray-600">
            We've sent a password reset link to <strong>{email}</strong>
          </p>
          <p className="text-sm text-gray-600">
            The link will expire in 1 hour for security reasons.
          </p>
          
          <div className="mt-8">
            <Link 
              to="/login" 
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Back to Login
            </Link>
          </div>
        </div>
      </AuthPageLayout>
    );
  }

  return (
    <AuthPageLayout showFooter={false}>
      <div className="space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">
            Forgot Password
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        <AuthCard className="shadow-none p-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2 login-label">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 login-input"
                placeholder="Enter your email address"
              />
            </div>

            <AuthSubmitButton loading={loading} loadingText="Sending...">
              Send Reset Link
            </AuthSubmitButton>
          </form>
        </AuthCard>

        <div className="text-center">
          <Link 
            to="/login" 
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </AuthPageLayout>
  );
};

export default ForgotPassword;
